/** @format */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxFudisModule } from '@funidata/ngx-fudis';
import { TranslateModule } from '@ngx-translate/core';
import { SisCommonModule } from 'sis-common';
import { SisComponentsModule } from '../../sis-components.module';
import { SearchFilterCodeBookComponent } from './search-filters/search-filter-code-book/search-filter-code-book.component';
import { SearchFilterComboboxComponent } from './search-filters/search-filter-combobox/search-filter-combobox.component';
import { SearchFilterCooperationNetworksComponent } from './search-filters/search-filter-cooperation-networks/search-filter-cooperation-networks.component';
import { SearchFilterCourseUnitsComponent } from './search-filters/search-filter-course-units/search-filter-course-units.component';
import { SearchFilterCreditRangeComponent } from './search-filters/search-filter-credit-range/search-filter-credit-range.component';
import { SearchFilterCurriculumPeriodsComponent } from './search-filters/search-filter-curriculum-periods/search-filter-curriculum-periods.component';
import { SearchFilterDateRangeComponent } from './search-filters/search-filter-date-range/search-filter-date-range.component';
import { SearchFilterDateComponent } from './search-filters/search-filter-date/search-filter-date.component';
import { SearchFilterDeadComponent } from './search-filters/search-filter-dead/search-filter-dead.component';
import { SearchFilterDropdownSelectComponent } from './search-filters/search-filter-dropdown-select/search-filter-dropdown-select.component';
import { SearchFilterEducationsComponent } from './search-filters/search-filter-educations/search-filter-educations.component';
import { SearchFilterEmployeesComponent } from './search-filters/search-filter-employees/search-filter-employees.component';
import { SearchFilterModulesComponent } from './search-filters/search-filter-modules/search-filter-modules.component';
import { SearchFilterOpenUniversityCartStateComponent } from './search-filters/search-filter-open-university-cart-state/search-filter-open-university-cart-state.component';
import { SearchFilterOpenUniversityPaymentMethodComponent } from './search-filters/search-filter-open-university-payment-method/search-filter-open-university-payment-method.component';
import { SearchFilterOpenUniversityProductStateComponent } from './search-filters/search-filter-open-university-product-state/search-filter-open-university-product-state.component';
import { SearchFilterOrganisationIdComponent } from './search-filters/search-filter-organisation-id/search-filter-organisation-id.component';
import { SearchFilterPersonGroupComponent } from './search-filters/search-filter-person-group/search-filter-person-group.component';
import { SearchFilterQualificationStateComponent } from './search-filters/search-filter-qualification-state/search-filter-qualification-state.component';
import { SearchFilterStudyPeriodsComponent } from './search-filters/search-filter-study-periods/search-filter-study-periods.component';
import { SearchFilterStudyRightStateComponent } from './search-filters/search-filter-study-right-state/search-filter-study-right-state.component';
import { SearchFilterStudyTermsComponent } from './search-filters/search-filter-study-terms/search-filter-study-terms.component';
import { SearchFilterStudyYearsComponent } from './search-filters/search-filter-study-years/search-filter-study-years.component';
import { SearchFilterUniversitiesComponent } from './search-filters/search-filter-universities/search-filter-universities.component';
import { SearchFilterDirective } from './search-filters/search-filter.directive';
import { SearchResultCountsComponent } from './search-result-counts/search-result-counts.component';
import { SearchResultsComponent } from './search-results/search-results.component';
import { SearchComponent } from './search.component';

@NgModule({
    declarations: [
        SearchComponent,
        SearchResultsComponent,
        SearchResultCountsComponent,
        SearchFilterCodeBookComponent,
        SearchFilterComboboxComponent,
        SearchFilterCooperationNetworksComponent,
        SearchFilterCreditRangeComponent,
        SearchFilterCurriculumPeriodsComponent,
        SearchFilterDateRangeComponent,
        SearchFilterDirective,
        SearchFilterDropdownSelectComponent,
        SearchFilterOpenUniversityProductStateComponent,
        SearchFilterOpenUniversityPaymentMethodComponent,
        SearchFilterOrganisationIdComponent,
        SearchFilterQualificationStateComponent,
        SearchFilterCourseUnitsComponent,
        SearchFilterOpenUniversityCartStateComponent,
        SearchFilterStudyPeriodsComponent,
        SearchFilterUniversitiesComponent,
        SearchFilterStudyRightStateComponent,
        SearchFilterDeadComponent,
        SearchFilterDateComponent,
        SearchFilterEducationsComponent,
        SearchFilterEmployeesComponent,
        SearchFilterModulesComponent,
        SearchFilterStudyTermsComponent,
        SearchFilterStudyYearsComponent,
        SearchFilterPersonGroupComponent,
    ],
    imports: [CommonModule, SisCommonModule, SisComponentsModule, NgxFudisModule, TranslateModule],
    exports: [
        SearchComponent,
        SearchResultsComponent,
        SearchResultCountsComponent,
        SearchFilterCodeBookComponent,
        SearchFilterComboboxComponent,
        SearchFilterCooperationNetworksComponent,
        SearchFilterCreditRangeComponent,
        SearchFilterCurriculumPeriodsComponent,
        SearchFilterDateRangeComponent,
        SearchFilterDirective,
        SearchFilterDropdownSelectComponent,
        SearchFilterOpenUniversityProductStateComponent,
        SearchFilterOpenUniversityPaymentMethodComponent,
        SearchFilterOrganisationIdComponent,
        SearchFilterQualificationStateComponent,
        SearchFilterCourseUnitsComponent,
        SearchFilterOpenUniversityCartStateComponent,
        SearchFilterStudyPeriodsComponent,
        SearchFilterUniversitiesComponent,
        SearchFilterStudyRightStateComponent,
        SearchFilterDeadComponent,
        SearchFilterDateComponent,
        SearchFilterEducationsComponent,
        SearchFilterEmployeesComponent,
        SearchFilterModulesComponent,
        SearchFilterStudyTermsComponent,
        SearchFilterStudyYearsComponent,
        SearchFilterPersonGroupComponent,
    ],
})
export class CommonSearchModule {}
